import {request} from './request'
import { jsonp } from "vue-jsonp"
import jmkApi from './jmkApi';
import hdkApi from './hdkApi';
import artistApi from './artistApi';
import brandApi from './brandApi';
import newsApi from './newsApi';
import userApi from './userApi';
import posterApi from './posterApi'
import exhibitApi from './exhibitApi'
import literatureApi from './literatureApi';

const channelApi={
  // 根据分类id查找相关子分类结果
  getChannel:params=>{
    return request({url: '/ChannelApi/GetListByParentId',params:params});
  },
  
}
const searchAllApi={
  //搜索全部
  getSearchAll:params=>{
    let params2={
      page:params.page||1,
      pageSize:params.pageSize ||12,
      keywords:params.keywords || '',
      city:params.city || '',
      task_year:params.task_year || ''
    }
    return request({url:'/ShowApi/GetSearchAll',params:params2})
  }
}

const yearApi={
  getMinYear:params=>{
    // categoryid 1 专题  2 活动 3 节目
    // typeid为节目的子分类
    let params2={
      categoryid:params.categoryid || -1,
      typeid:params.typeid || -1,
    }
    return request({url:'/ShowApi/GetYearByTypeId',params:params2})
  }
}

const suggestionApi={
  toSuggestion:params=>{
    let params2={
      title:params.title || '',
      feedback_content:params.feedback || '',
      suggestion_content:params.suggestion || '',
      phone:params.phone || '',
      file_path: params.file_path || ''
    }
    return request({url:'/suggestionApi/Add',params:params2})
  }
}
const aboutApi={
  homeAbout:()=>{
    return request({url:'/AboutApi/GetAbout'})
  }
}

const recordApi={
  recordApis:(config)=>{ // 0首页、1专题、2活动、3节目、4新闻、5人才库,6文学库、7展品库、8海报库
    const bannerObj = { 
      "首页": "0", 
      "专题": "1", 
      "活动": "2", 
      "节目": "3", 
      "新闻": "4", 
      "人才": "5", 
      "文学": "6", 
      "展品": "7", 
      "海报": "8", 
      "搜索": "88"
    }
    const banner = bannerObj[config.banner]

    const params = {
      banner,
      vid: config.id,
      category: config.category || 1,
      ip: window.ip,
      mobile: 2,
      _t:new Date().getTime()
    }
    if (config.type || config.type === 0 || config.type === '0') {
      params.type = config.type
    }
    if (config.user_id) {
      params.user_id = config.user_id
    }
    return request({ url: '/BrowsingRecordApi/Add', params })
  },

  addListRecord:(name, type)=>{
    let params = {
      banner:name,
      type,
    }
    recordApi.recordApis(params)
  },

  /**
   *  用户操作行为接口
   * @param {*} params 
   * banner：  0首页、1专题、2活动、3节目、4新闻、5人才库、6文学库、7展品库、8海报库
   * category： 1查看，2下载,3点赞，4关注
   * @returns 
   */

  addUserAction: (params) => {
    params.ip = window.ip
    params.mobile = 2
    params._ = new Date().getTime()
    return request({url: '/BrowsingRecordApi/Add', params})
  },
  checkUserAction: (params) => {
    return request({url: '/BrowsingRecordApi/GetByExist', params})
  }

}

const outLink = {
  getUserIpConfig(url) {
    return new Promise((resolve, reject) => {
      jsonp(url, {
        output: 'jsonp'
      }).then(resp => {
        resolve(resp)
      }).catch(err => {
        console.log(err);
      })
    })
  }
}

const bookApi={
  getBookOne(id){
    return request({
      url: "http://gdzknewcms.wanjuan.cn/api/book/get?id=4713",
      method: "POST"
    })
  }
}

export default {
  jmkApi,
  hdkApi,
  artistApi,
  brandApi,
  channelApi,
  newsApi,
  searchAllApi,
  userApi,
  yearApi,
  suggestionApi,
  aboutApi,
  recordApi,
  outLink,
  bookApi,
  posterApi,
  exhibitApi,
  literatureApi
}